import React, { Fragment } from "react";

function Button5() {
  return (
    <Fragment>
      <div className="text-center p-5">
        <a href="https://tangled.ae/Spellbound-Robot/entry.php?val=0">
          <button type="button" class="btn-lg btn-secondary">
            Stop
          </button>
        </a>
      </div>
    </Fragment>
  );
}

export default Button5;
